'use strict';

(function () {
  angular.module('sis-components.constant.warningLimits', []).constant('WarningLimits', {
    COURSE_UNIT_EXPIRY_WARNING_PERIOD_MONTHS: 12,
    MODULE_EXPIRY_WARNING_PERIOD_MONTHS: 12
  });
})();